import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import ChatView from '../../components/shared/ChatView';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DistributorChatPage = () => {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const [convo, setConvo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConvo = async () => {
      try {
        const res = await axios.get(`${API}/messages/conversations`);
        const found = res.data.find(c => c.id === conversationId);
        setConvo(found || null);
      } catch (error) { console.error('Failed to load conversation:', error); } finally { setLoading(false); }
    };
    fetchConvo();
  }, [conversationId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-12 h-12 rounded-full border-4 border-teal-100 border-t-teal-500 animate-spin" />
      </div>
    );
  }

  if (!convo) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400 text-sm">Conversación no encontrada</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[calc(100vh-80px)]" data-testid="distributor-chat-view">
      {/* Chat Header */}
      <div className="px-4 py-3 border-b border-gray-100 bg-white/80 backdrop-blur-lg">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/distributor/messages')}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
            data-testid="back-to-conversations">
            <ArrowLeft size={16} className="text-gray-600" />
          </button>
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center shadow-lg shadow-blue-500/20">
            <span className="text-white font-bold text-sm">{convo.client_name?.charAt(0)?.toUpperCase()}</span>
          </div>
          <div>
            <p className="font-bold text-gray-900 text-sm">{convo.client_name}</p>
            {convo.client_display_id && (
              <span className="text-[10px] font-mono text-blue-500">{convo.client_display_id}</span>
            )}
          </div>
        </div>
      </div>
      <ChatView
        conversationId={convo.id}
        partnerName={convo.client_name}
        accentColor="#0D9488"
      />
    </div>
  );
};

export default DistributorChatPage;
